import { Component, OnInit } from '@angular/core';
import {EventsManager} from "../../events/events.manager";
import {PlansService} from "../../services/plans.service";
import {GetDocumentDetailRequest} from "../../models/document.request";

@Component({
  selector: 'app-support',
  templateUrl: './support.component.html',
  styleUrls: ['./support.component.scss']
})
export class SupportComponent implements OnInit {
  plans:any = {};
  currentYear:number = 2025;
  prevFeeUrl:string = '';
  prevDiscountUrl:string = '';
  currFeeUrl:string = '';
  currDiscountUrl:string = '';
  stateChosen:boolean = false;
  currentState:any = {};
  selectedState:string = '';
  stateAbbr:string = '';
  info:any = {};
  constructor( private plansSrvc: PlansService, public em:EventsManager) { }

  ngOnInit(): void {
   this.plans = this.em.getOfficeInfo();
   console.log(this.plans);
   if(sessionStorage['state']){
     this.currentState = JSON.parse(sessionStorage['state']);
     this.selectedState = this.currentState.name;
     this.stateAbbr = this.currentState.abbr;
     this.stateChosen = true;
     this.getPlanDocuments();
   }
   this.info = this.em.contactInfo;
    this.em.contactInfoUpdated.subscribe(
      (info:any) => {
        this.info = this.em.contactInfo;
      }
    )
  }

  stateChanged(state:any) {
    if(state.target.value !== 'none'){
      this.stateAbbr = state.target.value;
      this.stateChosen = true;
      state.target.blur();
      this.getPlanDocuments();
    } else {
      this.stateChosen = false;
    }
  }

  openUrl(url:string){
    console.log('url: ', url);
    switch(url){
      case "prevFees":
        console.log('url: ', this.prevFeeUrl);
        window.open(this.prevFeeUrl);
        break;
      case "prevDiscount":
        console.log('url: ', this.prevDiscountUrl);
        window.open(this.prevDiscountUrl);
        break;
      case "currFees":
        console.log('url: ', this.currFeeUrl);
        window.open(this.currFeeUrl);
        break;
      case "currDiscount":
        console.log('url: ', this.currDiscountUrl);
        window.open(this.currDiscountUrl);
        break;
    }

  }

  getPlanDocuments(){
    let docReq:GetDocumentDetailRequest = {category:'PlanDetails,MembershipAgreements',brand:'sgdp',year:(this.currentYear-1).toString(),organizationId:this.em.orgId,coverageLevelName:'',planName:'',state:this.stateAbbr};
    this.plansSrvc.getDocumentDetails(docReq).subscribe(
      (response) => {
        console.log('prev: ', response);
        let urls = response.split(",");
        this.prevFeeUrl = urls[1];
        this.prevDiscountUrl = urls[0];
      }
    );
    let docReq2:GetDocumentDetailRequest = {category:'PlanDetails,MembershipAgreements',brand:'sgdp',year:(this.currentYear).toString(),organizationId:this.em.orgId,coverageLevelName:'',planName:'',state:this.stateAbbr};
    this.plansSrvc.getDocumentDetails(docReq2).subscribe(
      (response) => {
        console.log('curr: ', response);
        let urls = response.split(",");
        this.currFeeUrl = urls[1];
        this.currDiscountUrl = urls[0];
      }
    )
  }
}
